export const enum ERentalStatus {
  Paid = 'payment_rental_paid',
  Unpaid = 'payment_rental_unpaid',
  Overpaid = 'payment_rental_overpaid',
  PartiallyPaid = 'payment_rental_partially_paid',
  Returned = 'payment_rental_returned',
}
